export default __webpack_public_path__ + "static/media/plus.5abe1d24.svg";